import { customFetch } from '../lib/network/Axios';
import type { OwnerKioskSetupStatus, OwnerSetupPayload } from '../types/ownerSetup.types';

export async function getOwnerSetupStatus(): Promise<OwnerKioskSetupStatus[]> {
  const response = await customFetch.get('/kiosks/configuration/setup-status');
  return Array.isArray(response.data) ? (response.data as OwnerKioskSetupStatus[]) : [];
}

export async function submitOwnerInitialSetup(
  kioskId: string,
  payload: OwnerSetupPayload,
): Promise<OwnerKioskSetupStatus> {
  const response = await customFetch.put(`/kiosks/${encodeURIComponent(kioskId)}/initial-setup`, payload);
  return response.data as OwnerKioskSetupStatus;
}
